/**
 * @generated SignedSource<<dff9c0b6323d4faf62367b32ac5a4569>>
 * @relayHash 395ef377c8fc50a877abe4ee0c990076
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/555.0.0-2026-04-14T15:58:38.329Z/loadAppDownloadItemSavedModalQuery

import { ConcreteRequest } from 'relay-runtime';
export type loadAppDownloadItemSavedModalQuery$variables = {
  daysSinceUsedApp: number;
  userId: string;
};
export type loadAppDownloadItemSavedModalQuery$data = {
  readonly viewer: {
    readonly user: {
      readonly hasUsedAppInLastDays: boolean | null;
    } | null;
  };
};
export type loadAppDownloadItemSavedModalQuery = {
  response: loadAppDownloadItemSavedModalQuery$data;
  variables: loadAppDownloadItemSavedModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "daysSinceUsedApp"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "days",
      "variableName": "daysSinceUsedApp"
    }
  ],
  "kind": "ScalarField",
  "name": "hasUsedAppInLastDays",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "loadAppDownloadItemSavedModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "loadAppDownloadItemSavedModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/555.0.0-2026-04-14T15:58:38.329Z/loadAppDownloadItemSavedModalQuery",
    "metadata": {},
    "name": "loadAppDownloadItemSavedModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "369401005781710a51e82e3964de39f5";

export default node;
